import { authConstants, envConstants } from '../constants'

const initialState = {
  user: null,
  error: null,
  loading: false,
  valid: false
}

export default function auth (state = initialState, action) {
  switch (action.type) {
    case authConstants.LOGIN:
      return { ...state, loading: true, error: null, valid: false }
    case authConstants.LOGIN_SUCCESS:
      window.localStorage.setItem(envConstants.ls.email, action.payload.email)
      window.localStorage.setItem(envConstants.ls.time, action.payload.time)
      window.localStorage.setItem(envConstants.ls.bearer, action.payload.bearer)
      return { ...state, user: action.payload, loading: false, valid: true, error: null }
    case authConstants.LOGIN_FAILURE:
      return { ...state, error: action.payload, loading: false, valid: false }
    case authConstants.LOGOUT:
      window.localStorage.removeItem(envConstants.ls.email)
      window.localStorage.removeItem(envConstants.ls.time)
      window.localStorage.removeItem(envConstants.ls.bearer)
      window.localStorage.clear()
      return { ...state, error: null, loading: false, valid: false, user: null }
    default:
      return state
  }
}
